import React, { Component } from 'react';
import moment from 'moment';
import Collapsible from 'react-collapsible';
import Countdown, { zeroPad } from 'react-countdown-now';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { connect } from 'react-redux';
import packageJson from '../../../package.json';
import api from '../../axios-local-api';
import Confirm from '../../components/UI/Confirm/Confirm';
import Error from '../../components/UI/Error/Error';
import Modal from '../../components/UI/Modal/Modal';
import Spinner from '../../components/UI/Spinner/Spinner';
import Success from '../../components/UI/Success/Success';
import Box from '../../hoc/Box/Box';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../store/actions/index';
import Counter from '../../components/Counter';
import classes from './NetworkTroubleshooting.css';

export class NetworkTroubleshooting extends Component {
  constructor(props) {
    super(props);
    this.rebootHandler = this.rebootHandler.bind(this);
    this.resetHandler = this.resetHandler.bind(this);
    this.optimizeHandler = this.optimizeHandler.bind(this);

    this.state = {
      success: false,
      error: false,
      action: null,
      result: null,
      confirmModal: false,
      upArrowsM: false,
    };
    // console.log("NetworkTroubleshooting props:", props);
  }

  closeHandlerM = () => {
    this.setState({
      upArrowsM: false,
    });
  };

  openHandlerM = () => {
    this.setState({
      upArrowsM: true,
    });
  };
  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetSettingsErrorSuccess();
  };
  confirmModalConfirmHandler = () => {
    if (this.state.action === 'Reboot the network?') {
      this.props.onRebootRouter();
    } else if (this.state.action === 'Proceed with factory reset?') {
      this.props.onResetRouter();
    } else if (this.state.action === 'Optimize your WiFi network?') {
      this.props.onOptimizeRouter();
    }
    this.closeModal();
  };
  confirmModalCancelHandler = () => {
    this.setState({ confirmModal: false });
  };
  closeModal = () => {
    this.setState({ confirmModal: false });
  };
  onOpenModal = (result, action) => {
    this.setState({
      confirmModal: true,
      result: result,
      action: action,
    });
  };
  rebootHandler() {
    this.onOpenModal(
      'This will interrupt connectivity for a few minutes.',
      'Reboot the network?'
    );
  }
  resetHandler() {
    this.onOpenModal(
      'Factory reset restores the device to the original factory settings. This may require you to reconnect all devices.',
      'Proceed with factory reset?'
    );
  }
  optimizeHandler() {
    this.onOpenModal(
      'This may interrupt connectivity for a few seconds.',
      'Optimize your WiFi network?'
    );
  }

  render() {
    if (this.props.error && !this.state.error) {
      this.setState({ error: true });
      this.props.onResetSettingsErrorSuccess();
    }
    if (this.props.success && !this.state.success) {
      this.setState({ success: true });
      this.props.onResetSettingsErrorSuccess();
    }

    let networkTroubleshootingContent;

    if (this.props.settingsLoading) {
      networkTroubleshootingContent = <Spinner />;
    } else if (
      this.props.realWan &&
      (!this.props.realWan.connectionState ||
        this.props.realWan.connectionState !== 'connected')
    ) {
      networkTroubleshootingContent = (
        <div style={{ padding: '20px' }}>
          This Network is disconnected. Please ask the customer to reconnect
          inorder to perform network troubleshooting tasks.
        </div>
      );

    } else if (this.props.checkingWan && this.props.timerStart) {
      networkTroubleshootingContent = (
        <div  id="NetworkRebootTxt" style={{ padding: '20px' }}>
          The network is restarting... estimated wait time is 2-10 minutes,
          elapsed time{' '}
          <Counter startDate={this.props.timerStart} />
        </div>
      );
    } else if (!this.props.realSettings && !this.props.realWan) {
      networkTroubleshootingContent = (
        <div style={{ padding: '20px' }}>
          Network Troubleshooting not available. Try to log in again form
          Gateway.
        </div>
      );
    } else {

      networkTroubleshootingContent = (
        <Box>
          <div className={classes.TitleArea}>
            <div>Network Reboot</div>
            <button
              title={this.props.isSteering
                ? 'Device is steering.'
                : this.props.firmwareDisplayUpdateSpinner
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''
                }

              className={classes.ActionButton}
              id="RebootButton"
              onClick={this.rebootHandler}
              disabled={
                (this.props.checkingWan && this.props.timerStart) ||
                (this.props.wan?.loaded && this.props.wan?.realWan?.connectionState === 'disconnected') ||
                this.props.firmwareDisplayUpdateSpinner ||
                this.props.isSteering  ||
                this.props.optimizeRouterDisplayUpdateSpinner
              }
            >
              Reboot
            </button>
          </div>
          <div className={classes.Separator} />
          <div className={classes.TitleArea}>
            <div>Network Optimization</div>
            <button
              className={classes.ActionButton}
              title={
                this.props.firmwareDisplayUpdateSpinner ? 'Please wait until Firmware Update has completed' : ''
              }
              id="OptimizeButton"
              onClick={this.optimizeHandler}
              disabled={(this.props.checkingWan && this.props.timerStart) ||
                (this.props.wan?.loaded && this.props.wan?.realWan?.connectionState === 'disconnected') ||
                this.props.firmwareDisplayUpdateSpinner}
            >
              Optimize
            </button>
          </div>
          <div className={classes.showDesktop}>
          <div className={classes.Separator} />
          <div className={classes.TitleArea}>
            <div>Factory Reset</div>
            <button
              className={classes.ActionButton}
              title={
                this.props.firmwareDisplayUpdateSpinner
                ? 'Please wait until Firmware Update has completed' :
                this.props.optimizeRouterDisplayUpdateSpinner ? 'Please wait until Network Optimization has completed' : ''
               }
              id="ResetButton"
              onClick={this.resetHandler}
              disabled={(this.props.checkingWan && this.props.timerStart) ||
                (this.props.wan?.loaded && this.props.wan?.realWan?.connectionState === 'disconnected') ||
                this.props.firmwareDisplayUpdateSpinner ||
                this.props.optimizeRouterDisplayUpdateSpinner }
            >
              Reset
            </button>
          </div>
          </div>

        </Box>
      );
    }

    let arrowM = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (this.state.upArrowsM) {
      arrowM = (
        <MdKeyboardArrowUp aria-label="arrow up" color={'gray'} size={'30px'} />
      );
    }

    return (
      <Box>
        <div className={classes.NetworkTroubleshooting}>
          <div className={classes.showDesktop}>
            <div className={classes.TitleArea}>
              <h3 style={{ paddingRight: 20 }}>Network Troubleshooting</h3>
            </div>
            <div className={classes.Separator} />
            {networkTroubleshootingContent}
          </div>
          <div
            className={[classes.showMobile].join(' ')}
            style={{ borderRadius: '5px 5px 0px 0px' }}
          >
            <Collapsible
              transitionTime={100}
              onOpening={() => {
                this.openHandlerM();
              }}
              onClosing={() => {
                this.closeHandlerM();
              }}
              trigger={
                <Box>
                  <div>
                    <div className={classes.MobileTitleArea}>
                      <div className={classes.Header}>
                        <h3>Network Troubleshooting</h3>
                      </div>
                      <button className={classes.OpenCloseButton}>
                        {arrowM}
                      </button>
                    </div>
                  </div>
                </Box>
              }
            >
              <div>
                {' '}
                <div className={classes.Separator} />
                {networkTroubleshootingContent}
              </div>
            </Collapsible>
          </div>
        </div>
        <Modal show={this.state.confirmModal} modalClosed={this.closeModal}>
          <Confirm
            id={'NetworkTroubleshootingConfirm'}
            action={this.state.action}
            result={this.state.result}
            confirm={this.confirmModalConfirmHandler}
            cancel={this.confirmModalCancelHandler}
            deviceGroupConfirmation
          />
        </Modal>
        <Modal
          show={this.state.success}
          modalClosed={this.successErrorResetHandler}
        >
          <Success id={'NetworkTroubleshootingSuccess'} />
        </Modal>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settingsLoading: state.settings.loading,
    settingsLoaded: state.settings.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    realWan: state.wan.realWan,
    realDevices: state.devices.realDevices,
    devicesByEquipment: state.devices.devicesByEquipment,
    checkingWan: state.wan.checkingWan,
    timerStart: state.wan.timerStart,
    success: state.settings.success,
    error: state.settings.error,
    isSteering: (state.devices.realDevices || []).some(d => d?.steering && d?.steering.forced
      && d?.steering?.forced?.expiresAt && moment().isBefore(moment(d.steering.forced.expiresAt))),
    wan: state.wan,
    firmwareDisplayUpdateSpinner : state.settings.firmwareDisplayUpdateSpinner,
    optimizeRouterDisplayUpdateSpinner: state.settings.optimizeRouterDisplayUpdateSpinner,
    originalUpnp: state.upnp.realUpnp
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRebootRouter: () => dispatch(actions.rebootRouter(false, false)),
    onResetRouter: () => dispatch(actions.resetRouter()),
    onOptimizeRouter: () => dispatch(actions.optimizeRouter()),
    onResetSettingsErrorSuccess: () =>
      dispatch(actions.resetSettingsErrorSuccess()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(NetworkTroubleshooting, api));
